// import { currencyFormat } from '../Shared/Table/helpers';
import i18next from 'i18next';
import permissions from '../../config/permissions';
import { CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import { ReactComponent as ShippedIcon } from '../../assets/icons/shipped.svg';
import { ReactComponent as PendingIcon } from '../../assets/icons/pending.svg';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';

export const CLAIM_REPORTS_STATUSES = {
  reported: 'reported',
  reportable: 'reportable',
};

export const CLAIM_REPORTS_STATUSES_OPTIONS = [
  {
    label: i18next.t('tables:reported'),
    value: CLAIM_REPORTS_STATUSES.reported,
    icon: ShippedIcon,
    enabledForNonSponsors: false,
  },
  {
    label: i18next.t('tables:reportable'),
    value: CLAIM_REPORTS_STATUSES.reportable,
    icon: PendingIcon,
    enabledForNonSponsors: false,
  },
];

export const CLAIM_REPORTS_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:createdBy'),
    accessorKey: 'createdBy',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:totalAmount'),
    accessorKey: 'totalAmount',
    filter: {
      filterType: FILTER_TYPES.PRICE,
    },
    cell: {
      formattedFunction: (value) => {
        return '$ ' + (value ? Number(value) : 0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      } //currencyFormat,
    },
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:totalCPTs'),
    accessorKey: 'totalCPTs',
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 320,
    header: i18next.t('tables:claimReportGeneratedTimestamp'),
    accessorKey: 'claimReportGeneratedTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
];
